import ApplicationSummaryBadge from './ApplicationSummaryBadge';
export default ApplicationSummaryBadge;
